import { createSelector } from 'reselect';
import { ReduxStore } from '../ducks';

export const userSearch = (state: ReduxStore) => state.userSearch;
export const userSearchSelectedResult = createSelector(userSearch, (userSearch) => userSearch.selectedResult);
